import { z } from 'zod';
import { idArray, reportTimezoneSchema } from './shared.schema';

export const salesReportValDetailReportFormatSchema = z.enum(['csv', 'xlsx']);

export const salesReportValDetailSchema = z
	.object({
		reportStartDate: z.iso.date().optional(),
		reportEndDate: z.iso.date().optional(),
		areaIds: idArray.optional(),
		branchIds: idArray.optional(),
		districtIds: idArray.optional(),
		facilityIds: z.array(z.string()).optional(),
		facilityNumber: z.union([z.string(), z.number()]).optional(),
		timezone: z.union([z.literal('facility'), reportTimezoneSchema]).optional(),
		format: salesReportValDetailReportFormatSchema.default('csv'),
	})
	.superRefine((value, ctx) => {
		if (!value.reportStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['reportStartDate'],
				message: 'reportStartDate required',
			});
		}

		if (value.reportStartDate && value.reportEndDate && value.reportEndDate < value.reportStartDate) {
			ctx.addIssue({
				code: 'custom',
				path: ['reportEndDate'],
				message: 'reportEndDate must not be before reportStartDate',
			});
		}
	});

export type SalesReportValDetailParameters = z.infer<typeof salesReportValDetailSchema>;
export type SalesReportValDetailReportFormat = z.infer<typeof salesReportValDetailReportFormatSchema>;
